export {};
declare global {
  export interface Number {
    toPrice(): string;
  }
}
Number.prototype.toPrice = function (this: number) {
  return `${this.toFixed(2)} €`;
};
